import script from "./RegistroForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroForm.vue?vue&type=script&setup=true&lang=js"

import "./RegistroForm.vue?vue&type=style&index=0&id=858e589c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-858e589c"]])

export default __exports__